<template>
   <div class="activitydetails">

      <tabs :options="{ useUrlFragment: false }" cache-lifetime="0.01" v-if="activity.activityPrices || activity.activityFeatures || activity.activityInclusions || activity.activityHighlights || activity.activityWhatToBring || activity.activityTourtimes || activity.activityLocation || activity.activityLocationText || activity.activityTourtimes">

         <!-- Prices -->
         <tab name="Prices" v-if="activity.activityPrices">
            <div class="activityprices">
               <div class="activityprices__img" v-bind:style="{ background: 'url(' + activity.activityImages[2] + ')' + 'no-repeat center center' }"></div>
               <div class="container">
                  <ul class="activityprices__content">
                     <li class="activityprices__title"><h5>Prices</h5></li>
                     <li v-for="prices in activity.activityPrices" :key="prices">{{ prices }}</li>
                  </ul>
               </div>
            </div>
         </tab>

         <!-- Inclusions -->
         <tab name="Inclusions" v-if="activity.activityInclusions">
            <div class="activityinclusions">
               <div class="activityinclusions__img" v-bind:style="{ background: 'url(' + activity.activityImages[1] + ')' + 'no-repeat center center' }"></div>
               <div class="container">
                  <ul class="activityinclusions__content">
                     <li class="activityinclusions__title"><h5>Inclusions</h5></li>
                     <li v-for="inclusions in activity.activityInclusions" :key="inclusions">{{ inclusions }}</li>
                  </ul>
               </div>
            </div>
         </tab>

         <!-- Features -->
         <tab name="features" v-if="activity.activityFeatures">
            <div class="activityfeatures">
               <div class="activityfeatures__img" v-bind:style="{ background: 'url(' + activity.activityImages[3] + ')' + 'no-repeat center center' }"></div>
               <div class="container">
                  <ul class="activityfeatures__content">
                     <li class="activityfeatures__title"><h5>Features</h5></li>
                     <li v-for="features in activity.activityFeatures" :key="features">{{ features }}</li>
                  </ul>
               </div>
            </div>
         </tab>

         <!-- Highlights -->
         <tab name="Highlights" v-if="activity.activityHighlights">
            <div class="activityhighlights">
               <div class="activityhighlights__img" v-bind:style="{ background: 'url(' + activity.activityImages[0] + ')' + 'no-repeat center center' }"></div>
               <div class="container">
                  <ul class="activityhighlights__content">
                     <li class="activityhighlights__title"><h5>Highlights</h5></li>
                     <li v-for="highlights in activity.activityHighlights" :key="highlights">{{ highlights }}</li>
                  </ul>
               </div>
            </div>
         </tab>

         <!-- What to Bring -->
         <tab name="What to bring" v-if="activity.activityWhatToBring">
            <div class="activitywhattobring">
               <div class="activitywhattobring__img" v-bind:style="{ background: 'url(' + activity.activityImages[1] + ')' + 'no-repeat center center' }"></div>
               <div class="container">
                  <ul class="activitywhattobring__content">
                     <li class="activitywhattobring__title"><h5>What To Bring</h5></li>
                     <li v-for="wtb in activity.activityWhatToBring" :key="wtb">{{ wtb }}</li>
                  </ul>
               </div>
            </div>
         </tab>

         <!-- Tour Times -->
         <tab name="Times" v-if="activity.activityTourtimes">
            <div class="activitytourtimes">
               <div class="activitytourtimes__img" v-bind:style="{ background: 'url(' + activity.activityImages[2] + ')' + 'no-repeat center center' }"></div>
               <div class="container">
                  <ul class="activitytourtimes__content">
                     <li class="activitytourtimes__title"><h5>Times</h5></li>
                     <li v-for="times in activity.activityTourtimes" :key="times">{{ times }}</li>
                  </ul>
               </div>
            </div>
         </tab>

         <!-- Location -->
         <tab name="Location" v-if="activity.activityLocation || activity.activityLocationText || activity.activityLocationInfo || activity.activityLocationBlocks">
            <div class="activitylocation">
               <div class="container">
                  <div class="activitylocation__content">
                     <h5>Departure location</h5>
                     <p v-if="activity.activityLocationText">{{ activity.activityLocationText }}</p>
                     <p v-if="activity.activityLocation">{{ activity.activityLocation }}</p>
                     <p v-if="activity.activityLocationInfo"> {{ activity.activityLocationInfo }}</p>
                     <p v-if="activity.activityLocationBlocks" v-for="location in activity.activityLocationBlocks" :key="location"> {{ location }}</p>
                  </div>
               </div>

               <div class="activitylocation__map">
                  <GmapMap :center="{lat: activity.activityCenterLat, lng: activity.activityCenterLong}" :zoom="17" map-type-id="terrain">
                     <GmapMarker :position="{lat: activity.activityMarkerLat, lng: activity.activityMarkerLong}" :clickable="false" :draggable="false"></GmapMarker>
                  </GmapMap>
               
               </div>
            </div>
         </tab>
      </tabs>

      <div class="activityother" v-else-if="activity.activityOther || activity.activityOtherBlocks">
         <div class="activityother__info-wrap">
            <ul class="activityrestaurant__info">
               <li v-if="activity.activityOther">{{ activity.activityOther }}</li>
               <li v-for="otherBlocks in activity.activityOtherBlocks" :key="otherBlocks">{{ otherBlocks }}</li>
            </ul>
         </div>
         <div class="activityother__img">
            <div v-bind:style="{ background: 'url(' + activity.activityImages[1] + ')' + 'no-repeat center center' }"></div>
         </div>
      </div>

      <div class="activityimg" v-else-if="!activity.activityRestaurant">
         <div class="activityimg__img">
            <div v-bind:style="{ background: 'url(' + activity.activityImages[2] + ')' + 'no-repeat center center' }"></div>
         </div>
      </div>

      <div class="activityrestaurant" v-if="activity.activityRestaurant">
         <div class="activityrestaurant__info-wrap">
            <ul class="activityrestaurant__info">
               <li v-for="restInfo in activity.activityRestaurantInfo" :key="restInfo">{{ restInfo }}</li>
            </ul>
         </div>
         <div class="activityrestaurant__img">
            <div v-bind:style="{ background: 'url(' + activity.activityImages[2] + ')' + 'no-repeat center center' }"></div>
         </div>
      </div>

   </div>
</template>

<script>
   export default {
      name: 'activityDetails',
      props: ['activity'], 
   }
</script>
